export default __webpack_public_path__ + "static/media/logo.76c15636.png";